<template>
    <v-carousel v-model="carouselItem" height="calc(100vh - 120px)" delimiter-icon="mdi-movie">

        <v-carousel-item v-if="$props.section.videoLink">
            <v-sheet height="100%" tile color="#ffffff" width="100%" class="tutorial-sheet">
                <v-container class="frame-container">
                    <!-- <iframe class="frame" src="https://www.youtube.com/embed/363-3Lvgstg" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe> -->
                    <iframe class="frame" :src="$props.section.videoLink" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                </v-container>
            </v-sheet>
        </v-carousel-item>

        <v-carousel-item v-if="$props.section.documentationLink">
            <v-sheet height="100%" tile color="#ffffff" width="100%" class="tutorial-sheet documentation" light>
                <div class="documentation-container">
                    <p v-html="documentationHtml" />
                </div>
            </v-sheet>
        </v-carousel-item>

    </v-carousel>
</template>

<script>
export default {
    name: 'InfoSection',
    props: ['section'],
    components: {
    },
    data: () => ({
        carouselItem: 0,
        carouselShow: false,
        documentationHtml: ''
    }),

    computed: {
        accessKey() {
            return this.$store.state.tutorialsAccessKey;
        }
    },

    methods: {
        setFrameHeight: function() {
            console.log('resize frame!!');
            if(document.getElementsByClassName('frame')[0]) {
                let w = document.getElementsByClassName('frame')[0].offsetWidth;
                document.getElementsByClassName('frame')[0].style.height = `${((9/16) * w)}px`;
            }
        },

        setIcons: function() {
            let iconElements = document.getElementsByClassName('v-icon notranslate mdi mdi-movie theme--dark');
            if(iconElements[1]) {
                document.getElementsByClassName('v-icon notranslate mdi mdi-movie theme--dark')[1].classList.add('mdi-card-text-outline');
                document.getElementsByClassName('v-icon notranslate mdi mdi-movie theme--dark')[1].classList.remove('mdi-movie');
            }
            else if(!this.$props.section.videoLink) {
                document.getElementsByClassName('v-icon notranslate mdi mdi-movie theme--dark')[0].classList.add('mdi-card-text-outline');
                document.getElementsByClassName('v-icon notranslate mdi mdi-movie theme--dark')[0].classList.remove('mdi-movie');
            }
        },

        getDocumentation: function() {
            if(this.$props.section.documentationLink) {
                let docRoute = `${this.$props.section.documentationLink}?access=${this.accessKey}`;
                this.$http.get(docRoute).then(response => {
                    console.log(response);
                    this.documentationHtml = response.bodyText;
                });
            }
        }

    },

    mounted() {
        this.getDocumentation();
        this.setFrameHeight();
        window.addEventListener('resize', this.setFrameHeight);
    },

    updated() {
        this.setIcons();
    },

    destroyed() {
        window.removeEventListener('resize', this.setFrameHeight);
    }

  
};
</script>

<style scoped>

    .tutorial-sheet {
        border-radius: 4px;
        text-align: center;
    }
    .tutorial-sheet.documentation {
        padding: 2em 4em;
    }

    .frame-container {
        /* box-shadow: 5px 5px 3px 0px rgba(0,0,0,0.75); */
    }

    .frame {
        box-shadow: 5px 5px 3px 0px rgba(0,0,0,0.75);
        max-width: 100%;
        max-height: 100%;
        width: calc(100% - 110px);
    }

    .documentation-container {
        text-align: left; 
        padding: 1em 4em;
        border: black solid 1px;
        width: 100%;
        height: calc(100% - 30px);
        overflow-y: auto;
    }

</style>
